import { render } from "./ValidationBox.vue?vue&type=template&id=9cfe250e&scoped=true"
import script from "./ValidationBox.vue?vue&type=script&lang=js"
export * from "./ValidationBox.vue?vue&type=script&lang=js"

import "./ValidationBox.vue?vue&type=style&index=0&id=9cfe250e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cfe250e"]])

export default __exports__